export const getLocalStorageItem = <ItemType extends string>(key: string) => {
    try {
        return localStorage.getItem(key) as ItemType
    } catch (e) {
        console.error(e)
    }
}

export const setLocalStorageItem = <ItemType extends string>(key: string, value: ItemType) => {
    try {
        localStorage.setItem(key, value)
    } catch (e) {
        console.error(e)
    }
}

export const clearLocalStorageItem = (key: string) => {
    try {
        localStorage.removeItem(key)
    } catch (e) {
        console.error(e)
    }
}
